import { useTrackEventAmplitude } from '../../../../../core/Tracking/Amplitude/Amplitude';
import {
    CommitmentLink,
    useCommitmentsLinks,
} from '../../../../../shared/hooks/useCommitmentsLinks';

export function usePrimaryNavCommitmentsLinks(): Array<
    CommitmentLink & {
        trackClick: () => void;
    }
> {
    const { trackEvent } = useTrackEventAmplitude();
    const { concept, impact, bCorp, agencies, ourCommitments } = useCommitmentsLinks();

    const links = [];

    if (concept) {
        links.push({
            ...concept,
            trackClick: () => {
                trackEvent((ampli, defaultProperties) => {
                    ampli.primaryNavConceptClicked({
                        ...defaultProperties,
                        block: 'primary_nav',
                    });
                });
            },
        });
    }

    if (agencies) {
        links.push({
            ...agencies,
            trackClick: () => {
                trackEvent((ampli, defaultProperties) => {
                    ampli.primaryNavLocalAgenciesClicked({
                        ...defaultProperties,
                        block: 'primary_nav',
                    });
                });
            },
        });
    }

    if (impact) {
        links.push({
            ...impact,
            trackClick: () => {
                trackEvent((ampli, defaultProperties) => {
                    ampli.primaryNavOurImpactClicked({
                        ...defaultProperties,
                        block: 'primary_nav',
                    });
                });
            },
        });
    }

    if (bCorp) {
        links.push({
            ...bCorp,
            trackClick: () => {
                trackEvent((ampli, defaultProperties) => {
                    ampli.primaryNavBCorpClicked({
                        ...defaultProperties,
                        block: 'primary_nav',
                    });
                });
            },
        });
    }

    if (ourCommitments) {
        links.push({
            ...ourCommitments,
            trackClick: () => {
                trackEvent((ampli, defaultProperties) => {
                    ampli.primaryNavCommitmentsClicked({
                        ...defaultProperties,
                        block: 'primary_nav',
                    });
                });
            },
        });
    }

    return links;
}
